export const enDE = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB Zweigniederlassung",
  url: "https://de.lassie.co",
  logo: "https://de.lassie.co/images/logo-with-name.svg",
  description:
    "The first preventative pet insurance for dogs and cats that works like your health insurance. Up to 100% cost coverage and €140 annually for preventative care.",
  email: "kontakt@lassie.de",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Münzstrasse 21",
    postalCode: "10178",
    addressLocality: "Berlin",
    addressCountry: "DE",
  },
  sameAs: [
    "https://www.facebook.com/Lassie.Deutschland/",
    "https://www.instagram.com/lassie_de/",
    "https://www.youtube.com/@lassie_co",
    "https://www.linkedin.com/company/lassieco/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Insurance",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Dog Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Health Insurance Mini",
              description:
                "Basic protection for dogs with coverage for illnesses and accidents. Covers operations, medical treatments and emergency care.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Health Insurance Midi",
              description:
                "Comprehensive protection for dogs with extended coverage. Includes operations, treatments, medicine, rehabilitation, food and up to 100€ preventive care budget per year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Health Insurance Maxi",
              description:
                "Premium protection for dogs with maximum coverage for all medical treatments. Unlimited coverage for operations and medical treatments, and up to 140€ preventive care budget per year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Surgery Insurance",
              description:
                "Surgery insurance for dogs with up to 100% cost coverage and unlimited surgery coverage. Protects against high surgery costs and covers pre- and post-treatments.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Liability Insurance",
              description:
                "Dog liability insurance with up to 10 million euros coverage per insured event. Protects against costs for personal injury, property damage and financial losses caused by the dog.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Cat Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Health Insurance Mini",
              description:
                "Basic protection for cats with coverage for illnesses and accidents. Covers operations, medical treatments and emergency care.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Health Insurance Midi",
              description:
                "Comprehensive protection for cats with extended coverage. Includes operations, treatments, medicine, rehabilitation, food and up to 100€ preventive care budget per year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Health Insurance Maxi",
              description:
                "Premium protection for cats with maximum coverage for all medical treatments. Unlimited coverage for operations and up to 140€ preventive care budget per year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Surgery Insurance",
              description:
                "Surgery insurance for cats with up to 100% cost coverage and unlimited surgery coverage. Protects against high surgery costs and covers pre- and post-treatments.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
